import type React from 'react';
import styled from 'styled-components';

const AlignRowWrapper = styled.div<Pick<AlignRowProps, 'justify'>>`
  display: flex;
  justify-content: ${props => props.justify ?? 'flex-start'};
`;
const FixedCol = styled.div<{ full?: boolean }>`
  flex: ${props => (props.full ? '1 1 auto' : '0 0 auto')};
  min-width: 0;
  max-width: 100%;
`;

export interface AlignRowProps extends React.HTMLAttributes<HTMLDivElement> {
  justify?: 'center' | 'flex-start' | 'flex-end' | 'full';
}

/**
 * Riga con funzionalità di allineamento
 */
export function AlignRow(props: AlignRowProps) {
  const { children, justify } = props;
  const alignment = justify == 'full' ? 'flex-start' : justify;

  return (
    <AlignRowWrapper justify={alignment}>
      <FixedCol full={justify == 'full'}>{children}</FixedCol>
    </AlignRowWrapper>
  );
}
